// Import Core Components Here
import PropTypes from "prop-types";
import React, { Component } from "react";
import { observer, inject } from "mobx-react";

// Import Depedency Component Here
import EmailInput from "./EmailInput";
import ForgotPassword from "./ForgotPassword";
import LoginSub from "./LoginSub";
import SocialLoginError from "./SocialLoginError";
import ResetPassword from "./ResetPassword";
import MissedFields from "./MissedFields";
import MobileNumberInput from "./MobileNumberInput";
import { Modal } from "arv-reactcomponents";
import PasswordInput from "./PasswordInput";
import Register from "./Register";
import UserNameInput from "./UserNameInput";
import { isAuthenticated } from "../../utils";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@inject("LoginStore", "MybagStore")
@observer
class Login extends Component {
  constructor() {
    super();
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    if (isAuthenticated()) {
      this.props.MybagStore.getMyBagDetails();
      this.props.LoginStore.setLoggedInData();
    }
  }

  get currentViewSelector() {
    const { currentView } = this.props.LoginStore;
    switch (currentView) {
      case "forgotPassword":
        return <ForgotPassword />;
      case "register":
        return <Register />;
      case "login":
        return <LoginSub />;
      case "missed":
        return <MissedFields />;
      case "socialLoginError":
        return <SocialLoginError />;
      case "resetPassword":
        return <ResetPassword />;
      default:
        return <LoginSub />;
    }
  }
  closeModal() {
    Analytics.trackEvent({
      action: Event.action.LOGIN_CANCEL,
      category: Event.category.LOGIN,
    });
    this.props.LoginStore.changeView("login");
    this.props.LoginStore.setloginModal(false);
  }
  render() {
    return (
      <Modal
        isOpen={this.props.LoginStore.isModalOpen}
        onClose={this.closeModal}
        className="nw-login"
      >
        {this.currentViewSelector}
      </Modal>
    );
  }
}

Login.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    setLoggedInData: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
    changeView: PropTypes.func.isRequired,
    currentView: PropTypes.string.isRequired,
  }).isRequired,
  MybagStore: PropTypes.shape({
    getMyBagDetails: PropTypes.func.isRequired,
  }).isRequired,
};

export { EmailInput, MobileNumberInput, PasswordInput, UserNameInput, Login };



// WEBPACK FOOTER //
// ./src/component/Login/index.js